module.exports = __webpack_public_path__ + "img/thanda-royal-zulu-fc.52623f68.png";